let _ = require("ES/lib/lodash");
let AuthedUserSession = require("./AuthedUserSession");
let is_pl = _.get(AuthedUserSession, ["is_privatelabel"], false);
let private_label_code = _.get(AuthedUserSession, ["privatelabel_code"]);
let pl_logo = _.get(
  AuthedUserSession,
  ["activeCompany", "LOGO"],
  is_pl ? "logo-" + private_label_code + ".png" : "logo-main.png"
);
let is_beta = AuthedUserSession.is_beta;

module.exports = {
  logo: is_pl
    ? "/myevents/img/" + pl_logo
    : "/myevents/img/logo-" + (is_beta ? "beta" : "main") + ".png",
  mp_logo: "/myevents/img/mp_logo.png",
  event_placeholder: is_pl
    ? "/myevents/img/event_placeholder_no_mp.png"
    : "/myevents/img/event_placeholder.png?v3",
};



// WEBPACK FOOTER //
// ./src/utils/ImageURLs.js